<template>
  <article id="user-login" class="user-wrapper">
    <form class="login-wrapper" @submit.prevent="handleSubmit">
      <div class="login-brand">
        <span class="lb-mark" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
            <path d="M3 8h11a3 3 0 1 0-3-3" /><path d="M3 12h15a3 3 0 1 1-3 3" /><path d="M3 16h9" />
          </svg>
        </span>
        <div class="lb-title">breezer 로그인</div>
        <div class="lb-sub">계정 하나로 모든 서비스를 이용하세요</div>
      </div>
      <div class="input-area">
        <input
          placeholder="아이디"
          v-model="id"
          @keydown.enter="login()"
          autocomplete="username"
          required
        />
        <input
          placeholder="비밀번호"
          v-model="password"
          type="password"
          @keydown.enter="login()"
          autocomplete="current-password"
          required
        />
      </div>
      <div class="check-area">
        <label class="checkbox-container">
          <input type="checkbox" v-model="rememberId" />
          <span class="checkmark"></span>
          <span class="label">아이디 저장</span>
        </label>
        <label class="checkbox-container">
          <input type="checkbox" v-model="autoLogin" />
          <span class="checkmark"></span>
          <span class="label">로그인 유지</span>
        </label>
      </div>
      <div class="desc-area">
        <div class="desc">{{ message }}</div>
      </div>
      <div class="button-area">
        <div class="login-button-area">
          <button class="login-button button" @click="login()">로그인</button>
        </div>
        <div class="etc-button-area">
          <label class="join-button btn" @click="clickJoin()">회원가입 |</label>
          <label class="find-account-button btn" @click="clickFindAccount()"
            >아이디/비밀번호 찾기</label
          >
        </div>
      </div>
      <div class="sns-login-area"></div>
    </form>
  </article>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import * as routerUtil from "@/common/utils/routerUtil";
import { LoginRequest } from "../class";
import UtilMixin from "@/common/mixins/UtilMixin";
import * as LSUtil from "@/common/utils/storage";

export default defineComponent({
  setup() {
    return {};
  },
  data() {
    return {
      title: "",
      id: "",
      password: "",
      rememberId: false,
      autoLogin: false,
      message: "",
    };
  },
  mixins: [UtilMixin],
  // components: { HoonyNavigation },
  methods: {
    clickJoin() {
      routerUtil.moveTo("/user/join");
    },
    clickFindAccount() {
      routerUtil.moveTo("/user/find");
    },
    async login() {
      console.log("try login");
      this.message = "";
      // 유효성 검사

      // 로그인 유지 확인

      // API 요청
      const request = new LoginRequest(this.id, this.password, this.autoLogin);
      const res = await this.getApi().user().login(request);
      console.log("UserInfo : ", res);
      if (res) {
        this.getCore().loginSuccess(res, true);

        if (this.rememberId) {
          LSUtil.setLSLoginId(this.id);
        }
      } else {
        this.message = "로그인 실패. 아이디와 비밀번호를 확인해주세요";
      }

      // 응답 후처리

      // 아이디 저장 확인
    },
  },
  created() {
    console.log("[LoginPage] created");
    window.scrollTo(0, 0);

    const rememberId = LSUtil.getLoginId();
    if (!this.getStringUtil().isEmpty(rememberId)) {
      this.rememberId = true;
      this.id = rememberId;
    }
  },
});
</script>

<style lang="scss" scoped></style>
